export default __webpack_public_path__ + "e4ca27125fbefa11fb5387a5b69b7c5a.png";